export default __webpack_public_path__ + "static/media/rfbin_3.fceb25c4.png";